import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 从 localStorage 获取保存的语言，如果没有则使用默认语言
const language = localStorage.getItem('language') || 'zh';

// 翻译资源
const resources = {
    en: {
        translation: {
            "language": "English",
            "change-language": "Change Language",
            "monitor": "Vehicle Monitoring",
            "exit": "Exit",
            "archives": "Vehicle File",
            "english": "English",
            "chinese": "简体中文",
            "viewImage": "View Image",
            "back": "Back",
            "operation": "Operation Statistics",
            "login": {
                "platform": "Vehicle Rental Operation Platform",
                "type": "Account Password Login",
                "username": "Username",
                "password": "Password",
                "captcha": "Captcha",
                "loginBtn": "Login",
                "success": "Login Successful!",
                "error": "Please enter the correct captcha!",
                "usernameRequired": "Please enter your username!",
                "passwordRequired": "Please enter your password!",
                "captchaRequired": "Please enter the captcha!",
                "goRegister": "No account? Register now",
                "noAccount": "No account?",
                "registerNow": "Register now",
                "forgotPassword": "Forgot Password?",
            },
            "register": {
                "title": "Email Registration",
                "username": "Username",
                "usernamePlaceholder": "4-20 characters, letters and numbers only",
                "usernameRequired": "Please enter your username!",
                "usernameLength": "Username must be 4-20 characters!",
                "usernameOnlyAlphanumeric": "Username can only contain letters and numbers!",
                "email": "Email",
                "emailPlaceholder": "Please enter your email",
                "emailRequired": "Please enter your email!",
                "emailInvalid": "Please enter a valid email address!",
                "verifyCode": "Email Code",
                "codePlaceholder": "6-digit verification code",
                "codeRequired": "Please enter the verification code!",
                "codeInvalid": "Verification code must be 6 digits!",
                "sendCode": "Send Code",
                "codeSentSuccess": "Verification code sent successfully!",
                "codeSendFailed": "Failed to send verification code!",
                "password": "Password",
                "passwordPlaceholder": "8-20 characters, must contain letters and numbers",
                "passwordRequired": "Please enter your password!",
                "passwordLength": "Password must be 8-20 characters!",
                "passwordMustContainLetter": "Password must contain at least one letter!",
                "passwordMustContainDigit": "Password must contain at least one digit!",
                "confirmPassword": "Confirm Password",
                "confirmPasswordPlaceholder": "Please confirm your password",
                "confirmPasswordRequired": "Please confirm your password!",
                "confirmPasswordNotMatch": "Passwords do not match!",
                "inviteCode": "Invite Code (Optional)",
                "inviteCodePlaceholder": "Enter invite code if you have one",
                "registerBtn": "Register",
                "registerSuccess": "Registration successful!",
                "registerFailed": "Registration failed!",
                "goLogin": "Already have an account? Go to Login",
            },
            "forgot": {
                "title": "Forgot Password",
                "email": "Email",
                "emailRequired": "Please enter your email!",
                "emailInvalid": "Please enter a valid email address!",
                "verifyCode": "Email Code",
                "codePlaceholder": "6-digit verification code",
                "codeRequired": "Please enter the verification code!",
                "codeInvalid": "Verification code must be 6 digits!",
                "sendCode": "Send Code",
                "codeSentSuccess": "Verification code sent successfully!",
                "codeSendFailed": "Failed to send verification code!",
                "newPassword": "New Password",
                "passwordPlaceholder": "8-20 characters, must contain letters and numbers",
                "passwordRequired": "Please enter your new password!",
                "passwordLength": "Password must be 8-20 characters!",
                "passwordMustContainLetter": "Password must contain at least one letter!",
                "passwordMustContainDigit": "Password must contain at least one digit!",
                "confirmPassword": "Confirm New Password",
                "confirmPasswordPlaceholder": "Please confirm your new password",
                "confirmPasswordRequired": "Please confirm your password!",
                "confirmPasswordNotMatch": "Passwords do not match!",
                "submitBtn": "Reset Password",
                "resetSuccess": "Password reset successfully!",
                "resetFailed": "Password reset failed!",
                "goLogin": "Back to Login",
                "goRegister": "No account? Register now",
            },
            "platform": "Vehicle Rental Operation Platform",
            "cancel":"Cancel",
            "onOk":"Ok",
            "batteryDischarge":"Whether The Battery Is Discharged",
            "pilot":"Is It Drivable",
            "input": {
                'placeholder': "Search Number"
            },
            user: {
                "name": "Miss Wang",
                "reset": "Reset Password",
                "logOut": "Log Out",
            },
            carInfo: {
                "title": "Basic Vehicle Information",
                "total": "Total Vehicles",
                "rented": "Rented Vehicles",
                "inventory": "Inventory Vehicles",
                "onLine": "Today Online",
                "car_id": "Number",
            },
            rightInfo: {
                "driverTitle": "Driver Information",
                "name": "Tan Jianci",
                "number": "Job Number",
                "telephones": "Telephones",
            },
            varehicleInformation: {
                "title": "Varehicle Information",
                "model": "Vehicle Model",
                "speed": "Current Speed",
                "battery": "Battery SOC",
                "mileage": "Total Vehicle Mileage",
                "today": "Today Mileage ",
                "motor": "Motor Model",
                "battery_Type": "Battery Type",
                "insurance": "Date Insurance",
                "maintenance": "Maintenance Countdown",
                "lease": "Purchase/Lease Contracts",
                "insure": "Insurance Contract",
            },
            health: {
                "title": "Vehicle Healthy Status ",
                "motor": "Motor Status",
                "battery": "Battery Status",
                "recuperate": "State of Charge",
                "flagTitle": "Remote Control",
                "flag": "Forced Power Failure",
            },
            rentReturn: { // 租还记录
                "title": "Rental and Return Cecords",
                "id": "Serial No",
                "people": "Hirer",
                "telephony": "Contact Details",
                "picture": "Picture",
                "date": "Rental Date",
                "deadline": "Deadline",
                "category": "Rental Model",
                "status": "Inspection Status",
                "inspect": "Inspection Information",
                "order": "Order No.",
                "location": "Return Point",
                "contract": "Rental Contract",
                "cost": "Cost Details",
                "view": "view",
            },
            maintain: { // 维保记录
                "title": "Maintenance Records",
                "date": "Maintenance Date",
                "category": "Maintenance Category",
                "section": "Maintenance Content",
            },
            incident: { // 事故处理和维权
                "title": "Accident Management and Advocacy",
                "date": "Date",
                "category": "Category",
                "accident": "Accident Information",
            },
            insurance: { // 保险记录     
                "title": "Insurance Records",
                "date": "Date of Purchase/Renewal",
                "category": "Insurance Category",
            },
            fence: {
                "title": "Electronic Fence Alarm",
                "alarm": "Vehicle {{carNumber}} has exceeded the electronic fence!",
                "noAlarm": "No alarm information",
                "clear": "Clear",
                "type": "Fence Breach",
            },
            reset: {
                "title": "Reset Password",
                "originalPassword": "Original Password",
                "newPassword": "New Password",
                "confirmPassword": "Confirm Password",
                "submit": "Submit",
                "success": "Password reset successfully!",
                "error": "Password reset failed!",
            },
            status: {
                "idle": "Idle",
                "normal": "Normal",
                "abnormal": "Abnormal",
                "pending": "Pending",
                "charging": "Needs Charging",
            },
            common: {
                "name": "Name",
                "mapError": "Map loading failed:",
                "selectCar": "Please select a vehicle or search for one!",
            },
        }
    },
    zh: {
        translation: {
            "language": "简体中文",
            "change-language": "切换语言",
            "monitor": "车辆监控",
            "exit": "退出",
            "archives": "车辆档案",
            "english": "English",
            "chinese": "简体中文",
            "viewImage": "查看图片",
            "back": "返回",
            "operation": "运营统计",
            "login": {
                "platform": "车辆租赁运营平台",
                "type": "账号密码登录",
                "username": "账号",
                "password": "密码",
                "captcha": "验证码",
                "loginBtn": "登录",
                "success": "登录成功！",
                "error": "请输入正确的验证码！",
                "usernameRequired": "请输入您的账号！",
                "passwordRequired": "请输入您的密码！",
                "captchaRequired": "请输入验证码！",
                "goRegister": "没有账号？立即注册",
                "noAccount": "没有账号？",
                "registerNow": "去注册",
                "forgotPassword": "忘记密码？",
            },
            "register": {
                "title": "邮箱注册",
                "username": "用户名",
                "usernamePlaceholder": "4-20位，仅支持字母和数字",
                "usernameRequired": "请输入用户名！",
                "usernameLength": "用户名长度需为4-20位！",
                "usernameOnlyAlphanumeric": "用户名只能包含字母和数字！",
                "email": "邮箱",
                "emailPlaceholder": "请输入您的邮箱",
                "emailRequired": "请输入邮箱！",
                "emailInvalid": "请输入有效的邮箱地址！",
                "verifyCode": "邮箱验证码",
                "codePlaceholder": "6位数字验证码",
                "codeRequired": "请输入验证码！",
                "codeInvalid": "验证码必须为6位数字！",
                "sendCode": "发送验证码",
                "codeSentSuccess": "验证码发送成功！",
                "codeSendFailed": "验证码发送失败！",
                "password": "密码",
                "passwordPlaceholder": "8-20位，必须包含字母和数字",
                "passwordRequired": "请输入密码！",
                "passwordLength": "密码长度需为8-20位！",
                "passwordMustContainLetter": "密码必须包含至少一个字母！",
                "passwordMustContainDigit": "密码必须包含至少一个数字！",
                "confirmPassword": "确认密码",
                "confirmPasswordPlaceholder": "请再次输入密码",
                "confirmPasswordRequired": "请确认密码！",
                "confirmPasswordNotMatch": "两次输入的密码不一致！",
                "inviteCode": "邀请码（可选）",
                "inviteCodePlaceholder": "有邀请码请输入",
                "inviteCodeInvalid": "邀请码无效或已失效！",
                "registerBtn": "注册",
                "registerSuccess": "注册成功！",
                "registerFailed": "注册失败！",
                "goLogin": "已有账号？去登录",
            },
            "forgot": {
                "title": "忘记密码",
                "email": "邮箱",
                "emailRequired": "请输入邮箱！",
                "emailInvalid": "请输入有效的邮箱地址！",
                "verifyCode": "邮箱验证码",
                "codePlaceholder": "6位数字验证码",
                "codeRequired": "请输入验证码！",
                "codeInvalid": "验证码必须为6位数字！",
                "sendCode": "发送验证码",
                "codeSentSuccess": "验证码发送成功！",
                "codeSendFailed": "验证码发送失败！",
                "newPassword": "新密码",
                "passwordPlaceholder": "8-20位，必须包含字母和数字",
                "passwordRequired": "请输入新密码！",
                "passwordLength": "密码长度需为8-20位！",
                "passwordMustContainLetter": "密码必须包含至少一个字母！",
                "passwordMustContainDigit": "密码必须包含至少一个数字！",
                "confirmPassword": "确认新密码",
                "confirmPasswordPlaceholder": "请再次输入新密码",
                "confirmPasswordRequired": "请确认密码！",
                "confirmPasswordNotMatch": "两次输入的密码不一致！",
                "submitBtn": "重置密码",
                "resetSuccess": "密码重置成功！",
                "resetFailed": "密码重置失败！",
                "goLogin": "返回登录",
                "goRegister": "没有账号？立即注册",
            },
            "platform": "车辆租赁运营平台",
            "cancel":"取消",
            "onOk":"确认",
            "batteryDischarge":"电池是否放电",
            "pilot":"是否可驾驶",
            "input": {
                'placeholder': "搜索编号"
            },
            user: {
                "name": "王小姐",
                "reset": "重置密码",
                "logOut": "登出",
            },
            carInfo: {
                "title": "车辆基本信息",
                "total": "车辆总数",
                "rented": "已租车辆",
                "inventory": "库存车辆",
                "onLine": "在线",
                "car_id": "编号",
            },
            rightInfo: {
                "driverTitle": "驾驶员信息",
                "name": "弹键次",
                "number": "工号",
                "telephones": "电话",
            },
            varehicleInformation: {
                "title": "车辆信息",
                "model": "车辆型号",
                "speed": "当前车速",
                "battery": "剩余电量",
                "mileage": "车辆总里程",
                "today": "今日里程",
                "motor": "电机型号",
                "battery_Type": "电池类型",
                "insurance": "保险日期",
                "maintenance": "保养倒计时",
                "lease": "购买/租赁合同",
                "insure": "保险合同",
            },
            health: {
                "title": "健康状态",
                "motor": "电机状态",
                "battery": "电池状态",
                "recuperate": "充电状态",
                "flagTitle": "远程控制",
                "flag": "强制断电",
            },
            rentReturn: { // 租还记录
                "title": "租还记录",
                "id": "序号",
                "people": "租用人",
                "telephony": "联系方式",
                "picture": "照片",
                "work_id": "工号",
                "date": "租用日期",
                "deadline": "截止日期",
                "category": "租用模式",
                "status": "点检状态",
                "inspect": "点检信息",
                "order": "订单编号",
                "location": "还车点",
                "contract": "租用合同",
                "cost": "费用明细",
                "view": "查看",
            },
            maintain: { // 维保记录
                "title": "维保记录",
                "date": "维保日期",
                "category": "维保类别",
                "section": "维保内容",
            },
            incident: { // 事故处理和维权
                "title": "事故处理和维权",
                "date": "日期",
                "category": "类别",
                "accident": "事故信息",
            },
            insurance: { // 保险记录     
                "title": "保险记录",
                "date": "购/续保日期",
                "category": "保险类别",
            },
            fence: {
                "title": "电子围栏报警",
                "alarm": "车辆 {{carNumber}} 超出电子围栏！",
                "noAlarm": "暂无报警信息",
                "clear": "清除",
                "type": "围栏越界",
            },
            reset: {
                "title": "重置密码",
                "originalPassword": "原密码",
                "newPassword": "新密码",
                "confirmPassword": "确认密码",
                "submit": "提交",
                "success": "密码重置成功！",
                "error": "密码重置失败！",
            },
            status: {
                "idle": "空闲",
                "normal": "正常",
                "abnormal": "异常",
                "pending": "待排查",
                "charging": "待充电",
            },
            common: {
                "name": "名字",
                "mapError": "地图加载失败:",
                "selectCar": "请先选择车辆或搜索车辆！",
            },
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: language, // 默认语言
        fallbackLng: 'zh', // 回退语言
        interpolation: {
            escapeValue: false // React 已经防止 XSS
        }
    });

export default i18n;